// src/features/permissions/components/ModuleAccessCard.tsx
import { Card } from '../../../app/components/foundation';
import type { RoleModuleAccess } from '../data/permissions.mock';
import { PermissionStatusBadge } from './PermissionStatusBadge';

export interface ModuleAccessCardProps {
  modules: RoleModuleAccess[];
}

/**
 * Workspace card: per-module access for this role (Dashboard,
 * Customers, Wallet, Orders, ...) each shown Active/Disabled. Rows
 * come straight from the `modules` prop (sourced via
 * usePermissionWorkspaceMock) — no fetching here. Reuses
 * PermissionStatusBadge since module access shares the same
 * active/disabled vocabulary as role status. Same list markup as
 * monitoring/components/MonitoringHealthCard.tsx combined with
 * dashboard/components/SystemHealthCard.tsx's row layout.
 */
export function ModuleAccessCard({ modules }: ModuleAccessCardProps) {
  return (
    <Card className="vania-permissions-workspace-card">
      <h2 className="vania-permissions-workspace-card-title">دسترسی ماژول‌ها</h2>

      {modules.length === 0 ? (
        <p className="vania-permissions-workspace-empty">دسترسی ماژولی برای این نقش ثبت نشده است.</p>
      ) : (
        <ul className="vania-permissions-workspace-list">
          {modules.map((module) => (
            <li key={module.id} className="vania-permissions-workspace-list-item">
              <span className="vania-permissions-workspace-list-primary">{module.moduleName}</span>
              <PermissionStatusBadge status={module.status} />
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
